import Vue from 'vue';
import Router from 'vue-router';
import index from '@/pages/index/index.vue';
import article from '@/pages/article/article.vue';
import careers from '@/pages/careers/careers.vue';
import elabDo from '@/pages/elabDo/elabDo.vue';
import news from '@/pages/news/news.vue';
import loading from '@/pages/loading/loading.vue';
import articleCenter from '@/pages/articleCenter/articleCenter.vue';
import damai from '@/pages/damai/damai.vue';
import feature from '@/pages/feature/feature.vue';
import elabIntroduce from '@/pages/elabIntroduce/elabIntroduce.vue';//Elab是谁
import elabCreator from '@/pages/elabCreator/elabCreator.vue';//Elab创始人
import elabDamai from '@/pages/elabDamai/elabDamai.vue';
import skyDetail from '@/pages/skyDetail/skyDetail.vue';

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'loading',
      components: {
        default: loading,
      },
    },
    {
      path: '/index',
      name: 'index',
      components: {
        default: index,
      },
    },
    {
      path: '/article',
      name: 'article',
      component: article,
    },
    {
      path: '/articleCenter',
      name: 'articleCenter',
      component: articleCenter,
    },
    {
      path: '/careers',
      name: 'careers',
      component: careers,
    },
    {
      path: '/elabDo',
      name: 'elabDo',
      component: elabDo,
    },

    {
      path: '/news',
      name: 'news',
      component: news,
    },
    {
      path: '/damai',
      name: 'damai',
      component: damai,
    },
    {
      path: '/feature',
      name: 'feature',
      component: feature,
    },
    {
      path:'/elabIntroduce',
      name: 'elabIntroduce',
      component: elabIntroduce,
    },
    {
      path:'/elabCreator',
      name: 'elabCreator',
      component: elabCreator,
    },
    {
      path:'/elabDamai',
      name: 'elabDamai',
      component: elabDamai,
    },
    {
      path:'/skyDetail',
      name: 'skyDetail',
      component: skyDetail,
    },

  ],
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js